import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "./PaymentForm";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { STRIPE_INFO } from "../constants";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const stripeAppearance = {
  theme: "flat",
  labels: "floating",
  variables: {
    colorPrimary: "#145a79",
    colorBackground: "#fff",
    colorText: "#868686",
    colorDanger: "#e73439",
    spacingUnit: "4px",
    borderRadius: "4px",
    fontFamily: "Montserrat, sans-serif",
  },
  rules: {
    ".Input": {
      color: "#333",
      fontSize: "14px",
      fontWeight: 600,
      backgroundColor: "#f9f9f9",
      border: "1px solid #ccc",
      padding: "12px",
      borderRadius: "4px",
    },
    ".Input--focus": {
      borderColor: "#145a79",
      boxShadow: "0 0 0 1px #145a79",
    },
    ".Label": {
      fontSize: "14px",
      fontWeight: 600,
      color: "#868686",
    },
    ".Label--invalid": {
      color: "#e73439",
    },
    ".Input--invalid": {
      fontSize: "14px",
      fontWeight: 600,
      color: "#e73439",
      borderColor: "#e73439",
    },
    ".Error": {
      color: "#e73439",
      fontSize: "12px",
      marginTop: "4px",
    },
    ".AccordionItem": {
      border: "1px solid #cbcbcb",
      borderRadius: "12px",
      padding: "20px",
      backgroundColor: "#fff",
      fontSize: "20px",
      fontWeight: 700,
    },
    ".RadioIcon": {
      width: "20px",
      height: "20px",
    },
    ".RadioIconOuter": {
      stroke: "#00bdff",
      fill: "#fff",
    },
    ".RadioIconInner--checked": {
      fill: "#00bdff",
      r: "18",
    },
  },
};

const PaymentFormWrapper = ({ nextStep = () => {} }) => {
  const [stripeInfo] = useLocalStorage(STRIPE_INFO, "");

  return (
    <Elements
      stripe={stripePromise}
      options={{
        appearance: stripeAppearance,
        clientSecret: stripeInfo.clientSecret,
      }}
    >
      <PaymentForm nextStep={nextStep} />
    </Elements>
  );
};

export default PaymentFormWrapper;
